import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { paymentRequest } from "../lib/payments";
import { AuthModal } from "../components/AuthModal";

export function PaymentPage() {
  const [params] = useSearchParams();
  const { user, loading } = useAuth();
  const [status, setStatus] = useState("pending");
  const [error, setError] = useState<string | null>(null);
  const [attempt, setAttempt] = useState(0);
  const [waiting, setWaiting] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const sessionId = params.get("session_id");
  const cancelled = params.get("cancelado") === "1";
  useEffect(() => {
    if (!user || !sessionId || cancelled) return;
    let active = true;
    let timer: number | undefined;
    let checks = 0;
    setError(null);
    setWaiting(true);
    async function check() {
      try {
        const result = await paymentRequest<{ status: string }>("stripe-status", { sessionId });
        if (!active) return;
        setStatus(result.status);
        if (result.status === "pending" && ++checks < 12) timer = window.setTimeout(check, 2500);
        else setWaiting(false);
      } catch (error) {
        if (active) {
          setError(error instanceof Error ? error.message : "Não foi possível consultar o pagamento.");
          setWaiting(false);
        }
      }
    }
    void check();
    return () => { active = false; window.clearTimeout(timer); };
  }, [user, sessionId, cancelled, attempt]);
  return <section className="page-container status-box">
    <h1>{cancelled ? "Pagamento cancelado" : status === "paid" ? "Pagamento confirmado!" : status === "refunded" ? "Pagamento reembolsado" : "Confirmando seu pagamento"}</h1>
    {cancelled ? <p>A compra não foi concluída. Você pode tentar novamente quando quiser.</p> : loading ? <p>Carregando sua conta…</p> : !user ? <><p>Entre na conta usada para fazer a compra.</p><button className="primary-button" onClick={() => setAuthOpen(true)}>Entrar</button></> : !sessionId ? <p>O link de pagamento está incompleto.</p> : <>
      <p role="status">{status === "paid" ? "Seu acesso já está disponível na biblioteca." : status === "refunded" ? "O acesso vinculado a este pagamento foi encerrado." : "Aguardando a confirmação da Stripe. O acesso será liberado após a confirmação."}</p>
      {error && <p role="alert">{error}</p>}
      {status === "pending" && !waiting && <button className="primary-button" onClick={() => setAttempt((value) => value + 1)}>Verificar novamente</button>}
    </>}
    <p><Link className="primary-button" to={cancelled ? "/vip" : "/minhas-compras"}>{cancelled ? "Voltar à oferta" : "Minhas compras"}</Link></p>
    <Link to="/">Voltar ao catálogo</Link>
    <AuthModal open={authOpen && !user} onClose={() => setAuthOpen(false)} />
  </section>;
}
